'use strict';

import execute_on from "../../../../libs/execute-on";
import {attachNumber} from "../../../../components/form/number";
import {swalErrorFire} from "../../../../plugins/sweet-alert/sweet-alert-default";

execute_on('survey.company.list', function ($page) {
    $page
        .on('click', '.restoreSurveyButton', showRestoreSurveyPopup)
        .on('change', '#unlimited-target', setSampleState)
        .on('change', '#sample\\.is_enabled', toggleSampleData)
        .on('click', '.restoreSurveySubmitButton', submitRestoreSurveyForm)
    ;
});

function showRestoreSurveyPopup(event) {
    event.preventDefault();

    const url = $(event.currentTarget).prop('href');
    const $surveyRestoreModal = $('#surveyRestoreModal');

    $surveyRestoreModal
        .modal('show')
        .find('.modal-content')
        .html('<div class="m-5 text-center">' +
            '<div class="spinner-border mb-3" role="status"></div>' +
            '<strong class="d-block">Loading data, please wait...</strong>' +
            '</div>')
        .load(url, function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }

            attachNumber($(event.delegateTarget));
            setSampleState();
        });
}

function submitRestoreSurveyForm(event) {
    event.preventDefault();

    const $restoreSurveyForm = $(document).find('form#restoreSurveyForm');

    const errorMessage = getValidationError($restoreSurveyForm);
    if (errorMessage) {
        swalErrorFire({
            title: 'Validation error',
            text: errorMessage,
        });

        return;
    }

    $restoreSurveyForm.submit();
}

function getValidationError(form) {
    const $form      = $(form);
    const $target    = $form.find('#sample\\.target');
    const respondentsCount = $form.find('#respondentsCount').val();
    const isDisabled = !$form.find('#sample\\.is_enabled').is(':checked');

    if (isDisabled) {
        return;
    }

    if (parseInt(respondentsCount) >= parseInt($target.val())) {
        return 'The survey cannot be restored with the same value in the target as actual or less respondents in survey. Please set target greater than actual.';
    }

    if (parseInt($target.val()) === parseInt($target.data('min'))) {
        return 'The survey cannot be restored with the same value in the target field. Please set target greater than actual.';
    }
}

function setSampleState() {
    const isUnlimitedTargetChecked = $(document.getElementById('unlimited-target')).is(':checked');
    $(document).find('#targetGeneral, #oversamplingGeneral').prop('readonly', isUnlimitedTargetChecked);
    $(document).find('.input-group-prepend, .input-group-append').children().prop('disabled', isUnlimitedTargetChecked);
}

function toggleSampleData() {
    $(document.getElementsByClassName('sample-enabled'))
        .slideToggle($(this).is(':checked'))
    ;
}
